import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { converTime } from "../CommonComponents/Common";
import CustomScrollbars from "../CommonComponents/CustomScrollbars";

const LeadHistory = ({ selectedLead, actionHistory, workflows }) => {
  const reducer = useSelector((state: any) => state);
  const {
    ProjectReducer: { projectList },
  } = reducer;

  const parseData = (item) => {
    const actionHistory = item?.action;
    const data: any = {
      action: actionHistory.action,
      label: actionHistory.name || actionHistory.action,
    };
    if (item?.session_id) {
      switch (actionHistory.action) {
        case "delay":
          data.description = `Waits for ${
            actionHistory.value || "a set time"
          } ${actionHistory.type || "days"} before proceeding.`;
          break;

        case "condition":
        case "dateCondition":
          data.description = `Branch logic: runs different paths based on specified conditions.`;
          break;

        case "call":
          const calleeDetailsStr =
            actionHistory?.calleeDetails &&
            typeof actionHistory.calleeDetails === "object"
              ? Object.entries(actionHistory.calleeDetails)
                  ?.map(([key, value]) => `${key}: ${value}`)
                  .join(", ")
              : "No callee details";

          const projectName = projectList?.find(
            (project) => project?._id === actionHistory.projectId
          )?.projectName;

          data.description = `Initiates a call using project ${
            projectName || "N/A"
          } and agent ${
            actionHistory?.agentName || "N/A"
          } to ${calleeDetailsStr}.`;
          break;

        case "insights":
          data.description =
            actionHistory?.fields?.length > 0 && actionHistory?.key?.length > 0
              ? `Collects insights using fields: [${actionHistory?.fields.join(
                  ", "
                )}] and keys: [${actionHistory?.key.join(", ")}].`
              : `Collects insights. No fields or keys selected yet.`;

          break;

        case "changeWorkflow":
          data.label = actionHistory.name || "Change Workflow";
          data.hasBottomHandle = false;
          data.isEndNode = true;

          const workflowName = workflows?.find(
            (workflow) => workflow?._id === actionHistory?.workflowId
          )?.workflows?.name;
          data.description = `Switches to workflow "${workflowName || ""}".`;
          break;

        default:
          data.label = actionHistory.action || "Unknown";
          data.description = `Custom action: ${
            actionHistory.action || "No action provided"
          }.`;
      }
    } else {
      data.label = item.action || "";
      data.description = `Lead added to this workflow `;
    }
    return data;
  };

  return (
    <CustomScrollbars height="50vh">
      <Box display="flex" flexDirection="column" gap={2} mb={2}>
        {actionHistory?.map((history, index) => {
          const parsedHistory = parseData(history);
          return (
            <Card
              key={index}
              sx={{
                borderRadius: 3,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                transition: "transform 0.15s ease, box-shadow 0.15s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                },
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Box gap={1.5}>
                  {history?.session_id && (
                    <Box className="flex-align-center" gap={0.5}>
                      <Typography variant="body2" fontWeight={600} mb={0.3}>
                        Session ID :
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {history?.session_id}
                      </Typography>
                    </Box>
                  )}

                  <Box className="flex-align-center" gap={0.5}>
                    <Typography variant="body2" fontWeight={600} mb={0.3}>
                      Type:
                    </Typography>
                    <Typography
                      variant="body2"
                      textTransform="capitalize"
                      color="text.secondary"
                    >
                      {parsedHistory?.action || "N/A"}
                    </Typography>
                  </Box>

                  <Box className="flex-align-center" gap={0.5}>
                    <Typography variant="body2" fontWeight={600} mb={0.3}>
                      Label:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {parsedHistory?.label}
                    </Typography>
                  </Box>
                  <Box className="flex-align-center" gap={0.5}>
                    <Typography variant="body2" fontWeight={600} mb={0.3}>
                      Description :
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {parsedHistory?.description}
                    </Typography>
                  </Box>
                  <Box className="flex-align-center" gap={0.5}>
                    <Typography variant="body2" fontWeight={600} mb={0.3}>
                      Date :
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {converTime(history?.historyCreationTime)}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </CustomScrollbars>
  );
};

export default LeadHistory;
